import { css } from "styled-components";

// Shared with the home page: each subject's color rises from the bottom of its photo.
export const subjectPhotoGradient = css`
	&::after {
		content: "";
		position: absolute;
		inset: 0;
		background: linear-gradient(0deg, var(--tone) 0%, var(--tone) 18%, transparent 62%);
		opacity: 0.94;
		pointer-events: none;
	}
`;
